<form [formGroup]="formGroup" xmlns="http://www.w3.org/1999/html">
  <ng-container [ngSwitch]="inputType">
    <!--  Numeric -->
    <nx-formfield *ngSwitchCase="'number'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input
        *ngIf="!mask"
        [formControlName]="formControlName"
        nxInput
        type="number"
        inputmode="decimal"
        (keydown)="limitInput($event)"
        [min]="min"
        [max]="max"
        [minlength]="minLength"
        [maxlength]="maxLength"
      />
      <input
        *ngIf="mask"
        [formControlName]="formControlName"
        nxInput
        type="number"
        inputmode="decimal"
        [nxMask]="mask"
        [min]="min"
        [max]="max"
        [minlength]="minLength"
        [maxlength]="maxLength"
      />
      <span *ngIf="prefix" nxFormfieldPrefix>{{ prefix | translate }}</span>
      <span *ngIf="suffix" nxFormfieldSuffix>{{ suffix | translate }}</span>
    </nx-formfield>

    <!--  Numeric -->
    <nx-formfield *ngSwitchCase="'email'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input *ngIf="!mask" [formControlName]="formControlName" nxInput type="email" [minlength]="minLength" [maxlength]="maxLength" />
      <input
        *ngIf="mask"
        [formControlName]="formControlName"
        nxInput
        type="email"
        [nxMask]="mask"
        [minlength]="minLength"
        [maxlength]="maxLength"
      />
      <span *ngIf="prefix" nxFormfieldPrefix>{{ prefix | translate }}</span>
      <span *ngIf="suffix" nxFormfieldSuffix>{{ suffix | translate }}</span>
    </nx-formfield>

    <!--  Checkbox -->
    <nx-checkbox [formControlName]="formControlName" *ngSwitchCase="'checkbox'" class="nx-margin-bottom-s">
      {{ label | translate }}
    </nx-checkbox>

    <!--  Number stepper -->
    <div *ngSwitchCase="'numberStepper'" class="dynamic-input_number-stepper">
      <nx-number-stepper
        [min]="1"
        [max]="500"
        [formControlName]="formControlName"
        [leadingZero]="false"
        [ngClass]="{ 'has-error': hasError }"
        size="normal"
      ></nx-number-stepper>
    </div>

    <!--  Yes no -->
    <qbe-radio-button-group
      *ngSwitchCase="'yesNo'"
      class="radio-button--full-width"
      [elementsInLine]="2"
      [elementsInLineMedium]="2"
      [elementsInLineLarge]="2"
    >
      <qbe-radio-button
        *ngFor="let button of yesNoValues; index as buttonIndex"
        (click)="handleRadioButtonsChange(buttonIndex)"
        class="radio-button-item"
        [ngClass]="{ 'has-error': hasError }"
        [selected]="selectedRadioButton === buttonIndex"
        >{{ button.label | translate | uppercase }}</qbe-radio-button
      >
    </qbe-radio-button-group>

    <!--  Phone number -->
    <nx-formfield *ngSwitchCase="'phoneNumber'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input nxInput [formControlName]="formControlName" inputmode="tel" nxMask="000-000-000" />
      <span nxFormfieldPrefix>+48</span>
    </nx-formfield>

    <!--  Post code -->
    <nx-formfield *ngSwitchCase="'postCode'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input [formControlName]="formControlName" nxInput nxMask="00-000" inputmode="numeric" autocomplete="postal-code" name="postal-code">
      <span *ngIf="prefix" nxFormfieldPrefix>{{ prefix | translate }}</span>
      <span *ngIf="suffix" nxFormfieldSuffix>{{ suffix | translate }}</span>
    </nx-formfield>

    <!-- PESEL -->
    <nx-formfield *ngSwitchCase="'pesel'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input [formControlName]="formControlName" nxInput name="pesel" inputmode="numeric" nxMask="00000000000"/>
    </nx-formfield>

    <!--  Select -->
    <nx-formfield *ngSwitchCase="'select'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <nx-dropdown
        [showFilter]="optionFilter"
        [filterPlaceholder]="placeholder || 'common.filter' | translate"
        [formControlName]="name"
      >
        <nx-dropdown-item *ngFor="let option of options" [value]="option.value" [disabled]="option.disabled">
          {{ option.label }}
        </nx-dropdown-item>
      </nx-dropdown>
    </nx-formfield>

    <!--   Grouped select -->
    <nx-formfield *ngSwitchCase="'groupedSelect'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <nx-dropdown [showFilter]="true" [filterPlaceholder]="placeholder || 'common.filter' | translate" [formControlName]="name">
        <nx-dropdown-group [label]="group.label | translate" *ngFor="let group of groupedOptions">
          <nx-dropdown-item [value]="option.value" *ngFor="let option of group.options">
            {{ option.label }}
          </nx-dropdown-item>
        </nx-dropdown-group>
      </nx-dropdown>
    </nx-formfield>

    <!--  Date -->
    <nx-formfield *ngSwitchCase="'date'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input
        *ngIf="!noWeekends"
        nxDatefield
        nxInput
        [parseFormat]="['YYYY/MM/DD', 'DD/MM/YYYY', 'DD.MM.YYYY']"
        displayFormat="DD/MM/YYYY"
        [datepicker]="startDatepicker"
        [formControlName]="formControlName"
        [min]="minDate"
        [max]="maxDate"
      />
      <input
        *ngIf="noWeekends"
        nxDatefield
        nxInput
        [parseFormat]="['YYYY/MM/DD', 'DD/MM/YYYY', 'DD.MM.YYYY']"
        displayFormat="DD/MM/YYYY"
        [datepicker]="startDatepicker"
        [formControlName]="formControlName"
        [min]="minDate"
        [max]="maxDate"
        [datefieldFilter]="filterOutWeekends"
      />
      <span nxFormfieldHint>{{ 'common.date_input.hint' | translate }}</span>
      <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
      <nx-datepicker #startDatepicker [startView]="startViewDate" [startAt]="startAtDate"></nx-datepicker>
    </nx-formfield>

    <!--  Time -->
    <nx-formfield *ngSwitchCase="'time'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input nxInput nxMask="00:00" [formControlName]="formControlName" />
      <span nxFormfieldHint>HH:MM</span>
    </nx-formfield>

    <!--   Year -->
    <ng-container *ngSwitchCase="'year'">
      <nx-formfield [label]="label | translate" class="year-picker" [ngClass]="{ 'has-error': hasError }">
        <input [formControlName]="formControlName" nxInput />
        <button nxPlainButton type="button" (click)="showYearPicker = true">
          <nx-icon name="calendar" class="picker-icon"></nx-icon>
        </button>
        <span nxFormfieldHint>{{ 'common.year_input.hint' | translate }}</span>
        <qbe-year-picker
          *ngIf="showYearPicker"
          style="z-index: 1"
          [startingYear]="currentYear"
          (yearChange)="handleYearChange($event)"
          (closeModal)="showYearPicker = false"
        ></qbe-year-picker>
      </nx-formfield>
    </ng-container>

    <!--  Radio -->
    <div *ngSwitchCase="'radio'" class="nx-margin-top-m">
      <nx-radio-group [name]="name.toString()" [formControlName]="formControlName" [ngClass]="{ 'has-error': hasError }">
        <nx-label *ngIf="label" class="nx-margin-bottom-m">{{ label | translate }}</nx-label>
        <nx-radio
          *ngFor="let option of options"
          [value]="option.value"
          [disabled]="option.disabled"
          [labelSize]="labelSize"
          class="nx-margin-bottom-m"
        >
          {{ option.label | translate }}
        </nx-radio>
      </nx-radio-group>
    </div>

    <!--  Text -->
    <nx-formfield *ngSwitchDefault [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <input
        *ngIf="!mask"
        [formControlName]="formControlName"
        nxInput
        [minlength]="minLength"
        [maxlength]="maxLength"
        [autocomplete]="autocompleteType || 'on'"
        [name]="name || ''"
        (paste)="handlePasteTextInput($event)"
        (change)="handleChangeTextInput($event)"
        (keyup)="handleKeyupTextInput()"
      />
      <input *ngIf="mask" [formControlName]="formControlName" nxInput [nxMask]="mask" [minlength]="minLength" [maxlength]="maxLength" [autocomplete]="autocompleteType || 'on'" [name]="name || ''"/>
      <span *ngIf="prefix" nxFormfieldPrefix>{{ prefix | translate }}</span>
      <span *ngIf="suffix" nxFormfieldSuffix>{{ suffix | translate }}</span>
    </nx-formfield>

    <!--  TextArea -->
    <nx-formfield *ngSwitchCase="'textarea'" [label]="label | translate" [ngClass]="{ 'has-error': hasError }">
      <textarea
        #textAreaElement
        [formControlName]="formControlName"
        nxInput
        [rows]="1"
        [minlength]="minLength"
        [maxlength]="maxLength"
        [name]="name || ''"
        (paste)="handlePasteTextInput($event)"
        (change)="handleChangeTextInput($event)"
        (keyup)="handleKeyupTextInput()"
      ></textarea>
    </nx-formfield>
  </ng-container>

  <nx-error *ngIf="errorMessage && errorMessage['key'] !== 'asyncValidatorMessage'" class="nx-margin-top-xs nx-margin-bottom-m">
    {{ 'forms.validator.' + errorMessage['key'] | translate : errorMessage }}
  </nx-error>
  <nx-error *ngIf="errorMessage && errorMessage['key'] === 'asyncValidatorMessage'" class="nx-margin-top-xs nx-margin-bottom-m">
    {{ errorMessage['params'].join('. ') }}
  </nx-error>
</form>
